import { mapSelectionsOdds } from "../mapSelectionsOdds";
export var mapMarketsSelectionsOdds = function (markets, oddStyle) {
    return markets.map(function (market) {
        market.selections = mapSelectionsOdds(market.selections, oddStyle);
        return market;
    });
};
//# sourceMappingURL=mapMarketsSelectionsOdds.js.map